import {GET_AdminTokenUserRegister} from '../constants/ActionTypes'

const INIT_STATE = {
    
   
    AdmintokenMessage:null,
   
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        
            case GET_AdminTokenUserRegister:
            return {
                AdmintokenMessage: action.body,
             
                
            }
           
            
        default:
            return state;
    }
}